<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="v-toolbar__content--left-wrap flex-container space-between nowrap">
        <v-app-bar-nav-icon v-if="email" @click="drawer = true" />
        <v-toolbar-title class="mr-4">
          <router-link :to="email ? '/participants' : '/'">
            <img src="@/styles/assets/stockli-logo-white.png" class="stockli__app-bar-logo" alt="Stockli, the Swiss Ski" />
          </router-link>
        </v-toolbar-title>
      </div>
      <!-- /v-toolbar__content--left-wrap -->
      <div class="app-bar__login">
        <router-link v-if="!email" class="btn login-btn" to="/login">Rep Login</router-link>
        <v-btn v-if="email" @click="Logout" class="btn login-btn" to="/login">Log Out</v-btn>
      </div>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app temporary left dark>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h5 mb-4">Stockli Demo Tool</v-list-item-title>
          <v-list-item-subtitle class="mb-4">
            <div class="mb-4">
              Logged in as:
              <br />
              {{ email }}
            </div>
            <div class="v-navbar__content--location">
              <div class="mb-2">Location: </div>
              <div v-if="location">{{ location.Name }}</div>
              <div v-else class="notset">No location set!</div>
            </div>
            <div v-if="tag" class="mt-4 flex-container">
              <div class="flex">
                Participant tag:
                <br />
                {{ tag }}
              </div>
              <v-btn @click="ClearTag" class="btn close-btn"><v-icon>mdi-close</v-icon></v-btn>
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list nav>
        <v-list-item-group>
          <v-list-item to="/participants">
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Participants</v-list-item-title>
          </v-list-item>
          <v-list-item to="/location">
            <v-list-item-icon>
              <v-icon>mdi-crosshairs-gps</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Change Location</v-list-item-title>
          </v-list-item>
          <v-list-item to="/unreturned">
            <v-list-item-icon>
              <v-icon>mdi-ski</v-icon>
            </v-list-item-icon>
            <v-list-item-title>View Unreturned Skis</v-list-item-title>
          </v-list-item>
          <v-list-item to="/info" class="nav__secondary nav__secondary--top">
            <v-list-item-icon>
              <v-icon>mdi-file-sign</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Customer Preregister</v-list-item-title>
          </v-list-item>
          <v-list-item @click="ClearCustomer" class="nav__secondary">
            <v-list-item-icon>
              <v-icon>mdi-account-cancel</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Reset Calculator Form</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role === 'admin'" to="/reports" class="nav__secondary">
            <v-list-item-icon>
              <v-icon>mdi-file-table</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Reports</v-list-item-title>
          </v-list-item>
          <v-list-item @click="Logout">
            <v-list-item-icon>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-footer absolute outlined class="text-caption">
        <v-container class="pa-0">
          <v-row no-gutters>
            <v-col>Client:</v-col>
            <v-col>{{ clientversion }}</v-col>
            <v-spacer />
          </v-row>
          <v-row no-gutters>
            <v-col>API:</v-col>
            <v-col>{{ apiversion }}</v-col>
            <v-spacer />
          </v-row>
        </v-container>
      </v-footer>
    </v-navigation-drawer>
    <v-main>
      <router-view v-on:tag-set="UpdateTag" />
    </v-main>
    <div class="stockli-footer">
      <div class="stockli-footer__inner">
        <nav class="mb-6">
          <img src="@/styles/assets/stockli-logo-white.png" class="stockli-footer__logo mb-4" alt="Stockli, the Swiss Ski" />

          <div class="stockli-footer__links mt-4 mb-4">
            <a href="https://www.stoeckli.ch/usen/" target="_blank" rel="noopener" class="bold-text">Stockli Main Site</a><span class="pipe">|</span>
            <a href="https://www.stoeckli.ch/usen/ski/ski-finder" target="_blank" rel="noopener" class="bold-text">Stockli Ski
              Finder</a><span class="pipe">|</span>
            <router-link to="/privacy" class="bold-text">Privacy
              Policy</router-link><span class="pipe">|</span>
            <router-link to="/terms" class="bold-text">Terms of
              Use</router-link>
          </div>
        </nav>
        <div class="copyright small-text">&copy; 2024 Stockli</div>
      </div>
    </div>
  </v-app>
</template>

<script>
import API from "@/services/api";

export default {
  name: "App",

  data: () => ({
    drawer: false,
    clientversion: undefined,
    apiversion: undefined,
    tag: undefined,
  }),
  computed: {
    email() {
      return this.$store.state.email;
    },
    role() {
      return this.$store.state.role;
    },
    location() {
      return this.$store.state.location;
    },
  },
  async mounted() {
    try {
      [this.clientversion, this.apiversion] = await Promise.all([
        API.GetClientVersion(),
        API.GetAPIVersion(),
      ]);
    } catch {
      console.error("Couldn't get versions");
    }
    this.tag = sessionStorage.getItem("Participant_Tag");
  },
  methods: {
    ClearCustomer() {
      this.$store.commit("SetSavedIndicator", undefined);
      this.$store.commit("ClearSkierInfo");
      this.$router.push("/");
    },
    UpdateTag() {
      this.tag = sessionStorage.getItem("Participant_Tag");
    },
    ClearTag() {
      sessionStorage.removeItem("Participant_Tag");
      this.$router.replace({ "query": null });
      this.tag = sessionStorage.getItem("Participant_Tag");
    },
    Logout() {
      this.$store.dispatch("Logout");
    },
  },
};
</script>
